module.exports = __webpack_public_path__ + "img/N@2x.d18cb1c4.jpg";